
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/files/[fileId]",
      function () {
        return require("private-next-pages/files/[fileId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/files/[fileId]"])
      });
    }
  